// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"DividerWithLogo_fullWidth__2ZeJy","IconContainer":"DividerWithLogo_IconContainer__2RXdA","spinAround":"DividerWithLogo_spinAround__3v3hB"};